'use client';

import FlatCardSquare from '@components/flat-card-square/FlatCardSquare';
import React from 'react';
import { useSelector } from 'react-redux';
import style from './FlatSimilar.module.scss';

const FlatSimilar = ({ similar }) => {
  const allFlats = useSelector(state => state?.filters?.flats);

  const filteredSimilar = similar.filter(fl => {
    const fullFlat = allFlats.find(f => f.id === fl.id);
    return fullFlat ? fullFlat.status !== 'reserve' : false;
  });

  return (
    <div className={style.flatSimilar}>
      <p className={style.flatSimilar__title}>Похожие квартиры</p>
      <div className={style.flatSimilar__flats}>
        {filteredSimilar?.slice(0, 3).map(el => {
          return <FlatCardSquare key={el.id} {...el} />;
        })}
      </div>
    </div>
  );
};

export default React.memo(FlatSimilar);
